<template>

  <div class="dingdan">

<!--    <breadcrumb :routerList="[{to:'/dingd/dingdmainlist',title:'订单管理'},{title:'用户单位'}]"/>-->
  <Breadtabsheader/>
    <div class="h-piece h-mrt30 margin">
      <div class="h-formBox">
        <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder" ref="form">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="单位名称/编码" prop="deptName">
              <el-input v-model="formInline.deptName" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="  省份" prop="province">
              <el-input v-model="formInline.province" placeholder="请输入"
                        style="width: 100%"></el-input>
            </el-form-item>
            <el-form-item label="  城市" prop="city">
              <el-input v-model="formInline.city" placeholder="请输入"
                        style="width: 100%"></el-input>
            </el-form-item>
            <el-form-item label="  区域" prop="area">
              <el-input v-model="formInline.area" placeholder="请输入"
                        style="width: 100%"></el-input>
            </el-form-item>
          </div>
            <div class="h-thirdColumn w-newColumn">
                <el-form-item label="  创建人" prop="cucode">
                    <el-input v-model="formInline.cucode" placeholder="请输入"
                              style="width: 100%"></el-input>
                </el-form-item>
                <el-form-item label="  审批状态">
                    <el-select v-model="formInline.spStatus"
                               placeholder="请选择"
                               clearable>
                        <el-option label="待审核" value=0></el-option>
                        <el-option label="通过" value=1></el-option>
                        <el-option label="驳回" value=2></el-option>
                    </el-select>
                </el-form-item>
              <el-form-item label="  渠道" prop="channelName">
                <brselectlazy category="channel_classification" :v="formInline.deptSourceChannel" v-model="formInline.deptSourceChannel"
                              :clearable="true"
                              style="width:100%"/>
              </el-form-item>
              <el-form-item label="用户分类" prop="schoolTypeName">
                <el-input v-model="formInline.schoolTypeName" placeholder="请输入"></el-input>
              </el-form-item>
            </div>
        </el-form>
        <div class="l-screenBox">
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
            </el-button>
            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
                       @click="createAddr()">
              新增用户单位
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="h-table h-mrt30 tableclslist">
      <el-table
          ref="ddtable"
          :data="tableData"
          stripe
          border
          :show-overflow-tooltip="true"
          style="width: 100%"
          max-height="450"
      >
        <el-table-column
            type="index"
            width="40"
            label="#"
            fixed
        >
        </el-table-column>
        <el-table-column
            fixed
            prop="deptName"
            label="单位名称"
            :show-overflow-tooltip="true"
            width="200">
        </el-table-column>
        <el-table-column
              prop="departmentCode"
              label="单位编码"
              :show-overflow-tooltip="true"
              width="200">
          </el-table-column>
        <el-table-column
            prop="creditCode"
            label="统一社会信用代码"
            :show-overflow-tooltip="true"
            width="200">
        </el-table-column>
        <el-table-column
            prop="deptSourceChannel2"
            label="渠道"
            :show-overflow-tooltip="true"
            width="100">
          <template scope="scope">
            {{scope.row.deptSourceChannel2|dictname('channel_classification')}}
          </template>
        </el-table-column>
          <el-table-column
                  prop="schoolTypeName2"
                  label="用户分类"
                  width="110">
          </el-table-column>
        <el-table-column
            prop="country"
            label="国家"
            width="110">
        </el-table-column>
        <el-table-column
            prop="province"
            label="省份"
            width="110">
        </el-table-column>
        <el-table-column
            prop="city"
            label="城市"
            width="100">
        </el-table-column>
        <el-table-column
            prop="area"
            label="区域"
            width="100">
        </el-table-column>
        <el-table-column
            prop="landmark"
            label="地标性"
            width="100">
        </el-table-column>
        <el-table-column
            prop="address"
            label="详细地址"
            :show-overflow-tooltip="true"
            width="260">
        </el-table-column>
        <el-table-column
            prop="spStatus"
            label="审批状态"
            :show-overflow-tooltip="true"
            width="110">
          <template scope="scope">
            <span v-if="scope.row.spStatus == 0">待审核</span>
            <span v-if="scope.row.spStatus == 1">通过</span>
            <span v-if="scope.row.spStatus == 2">驳回</span>
          </template>
        </el-table-column>

        <el-table-column
            prop="spyj"
            label="审批意见"
            :show-overflow-tooltip="true"
            width="150">
        </el-table-column>
          <el-table-column
                  prop="cucode"
                  label="创建人"
                  :show-overflow-tooltip="true"
                  width="120">
          </el-table-column>
          <el-table-column
                  prop="cdate"
                  label="创建时间"
                  :formatter="formatDate"
                  value-format="yyyy-MM-dd"
                  :show-overflow-tooltip="true"
                  width="120">
          </el-table-column>
          <el-table-column
                  prop="dataSource"
                  label="数据来源"
                  :show-overflow-tooltip="true"
                  width="100">
              <template scope="scope">
                  {{scope.row.dataSource|dictname('address_data_source')}}
              </template>
          </el-table-column>
          <el-table-column
                  prop="parentName"
                  label="上级名称"
                  :show-overflow-tooltip="true"
                  width="200">
          </el-table-column>
          <el-table-column
                  prop="parentCode"
                  label="上级编码"
                  :show-overflow-tooltip="true"
                  width="200">
          </el-table-column>
          <el-table-column
                  prop="deptNameLog"
                  label="单位名称曾用名"
                  :show-overflow-tooltip="true"
                  width="200">
          </el-table-column>
        <el-table-column
            fixed="right"
            label="操作"
            width="150"
        >
          <template slot-scope="scope">
            <div style="text-align: left;">
              <div style="text-align: left;">
                <el-button
                        v-if="!(scope.row.spStatus == 0 || scope.row.spStatus == 2)"
                    size="small" class="h-tableLink h-btn"
                    @click="handelDetail(scope.row.id)">修改
                </el-button>
                <el-button v-if="scope.row.instid"
                           size="small" class="h-tableLink h-btn"
                           @click="genzongLiuch(scope.row)">
                  跟踪
                </el-button>
                <el-button v-if="scope.row.spStatus == 2"
                           size="small" class="h-tableLink h-btn"
                           @click="chongxintijiao(scope.row.id)">
                  重新提交
                </el-button>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
        <pagination :page="formInline" @query="query"/>
      </div>
      <!--            审批窗口-->
      <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
      <el-dialog :close-on-click-modal="false"  @close='closeDialog' :visible.sync="institutionalX" class="h-dialog2">
        <companyName ref="companyName" :titleName = "titleDig" :add1 = "add" :updateId="updateId" :nameLog="true"  @getChildValue="closeCompanyName"></companyName>
      </el-dialog>


      <!-- 弹出层 -->
<!--      <el-dialog :close-on-click-modal="false"  @close='closeDialog' :visible.sync="newDialog" class="h-dialog2">
        <div class="h-dialogImg">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>{{titleDig}}</h1>
            </div>
          </div>
        </div>
        <div class="h-formLines">
&lt;!&ndash;            <h6 style="color: red;font-size: 0.14rem;margin-top: 0.1rem;">单位名称为大学时，请按实际情况维护用户分类(211/985)</h6>&ndash;&gt;
            <el-form ref="form" :model="add" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
            <el-form-item label="单位名称" class="h-elformWrap-2" label-width="100" prop="deptName" :rules="[{ required: true, message: '请输入单位名称', trigger: 'change'},]">
                <el-select v-model="add.deptName"  remote filterable :filter-method="selectDept" clearable placeholder="请输入" allow-create filterable
                           :remote-method="selectDept" @change="changeDeptName($event)" :rules="[{ required: true, message: '请输入单位名称', trigger: 'change'},]">
                    <el-option v-for="(item) in deptNameList"
                               :key="item.deptName"
                               :label="item.deptName"
                               :value="item.deptName">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item  label="渠道" class="h-elformWrap-2" label-width="100" prop="deptSourceChannel" :rules="[{ required: true, message: '请选择渠道', trigger: 'blur'},]">
              <brselect category="sales_region" :v="add.deptSourceChannel" :showcode="true" @change="changeChannel($event)"
                        v-model="add.deptSourceChannel" clearable></brselect>
            </el-form-item>
            <el-form-item  label="用户分类" class="h-elformWrap-2" label-width="100" prop="schoolTypeName" :rules="[{ required: true, message: '请输入用户分类', trigger: 'change'},]">
              <el-select v-model="add.schoolTypeName" :v="add.schoolTypeName" :rules="[{ required: true, message: '请输入用户分类', trigger: 'change'},]"
                         @change="changeSchoolType($event)"  placeholder="请选择" clearable>
                <el-option v-for="item in addressTypeList"
                           :key="item.id"
                           :label="item.userUnit"
                           :value="item.userUnit">
                </el-option>
              </el-select>
            </el-form-item>
              <el-form-item label="地标性" class="h-elformWrap-2" prop="landmark" label-width="100"
                            :rules="[{ required: true, message: '请选择地标性', trigger: 'change'},]">
                <el-select v-model="add.landmark" @change="clickGetSeal" placeholder="请选择" clearable>
                  <el-option label="KA" value="KA"></el-option>
                  <el-option label="省级" value="省级"></el-option>
                  <el-option label="地市级" value="地市级"></el-option>
                  <el-option label="区县级及以下" value="区县级及以下"></el-option>
                </el-select>
              </el-form-item>
            <el-form-item label="省" class="h-elformWrap-2"  style="width: 33.333%" prop="province" :rules="[{ required: true, message: '必须输入选项', trigger: 'blur'},]">
              <el-select v-model="add.province" @change="handleItemChange1" placeholder="省" >
                <el-option
                    v-for="item in shenglist"
                    :key="item.value"
                    :label="item.name"
                    :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="市" class="h-elformWrap-2" style="width: 33.333%" prop="city"
                          :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]">
              <el-select v-model="add.city" @change="handleItemChange2"
                         :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]"
                         placeholder="市" >
                <el-option
                    v-for="item in arealist2"
                    :key="item.value"
                    :label="item.name"
                    :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="区" class="h-elformWrap-2" style="width: 33.333%" prop="area"
                          :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]">
              <el-select v-model="add.area"
                         :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]"
                         placeholder="区" @change="handleItemChange3">
                <el-option
                    v-for="item in arealist3"
                    :key="item.value"
                    :label="item.name"
                    :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="上级" class="h-elformWrap-1" label-width="100" prop="deptName">
               <treeselect
                      :multiple="false"
                      :options="options"
                      :flat="true"
                      :default-expand-level="1"
                      placeholder="请选择"
                      v-model="stVal"
              />
              <treeselect-value :value="stVal" />
          </el-form-item>
            <el-form-item label="详细地址" class="h-elformWrap-1"
                          :rules="[
                        { required: true, message: '必须输入选项', trigger: 'blur'},
                        {  max: 30, message: '长度在30个字符以内', trigger: 'blur' }
                    ]"
                          prop="address">
              <el-input v-model="add.address" style="width: 84%;"></el-input>
            </el-form-item>

              <div style="font-size: 0.15rem;color: #ff2424;margin-bottom: 0.2rem;margin-left: 30px">*
                单位名称曾用名请用英文逗号形式隔开!
              </div>

              <el-form-item label="单位名称曾用名" class="h-elformWrap-1">
                <el-input type="textarea" style="border: #dedede 1px solid;
                                            width: 84%;" v-model="add.deptNameLog" ></el-input>
              </el-form-item>
          </el-form>
          <div style="display:flex;justify-content:center;margin-bottom:20px">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate(1)" v-if="this.insertFlag">提交</el-button>
            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate(2)" v-if="this.reFlag">提交</el-button>
          </div>
        </div>
      </el-dialog>
      <el-dialog :close-on-click-modal="false"  @close='closeDialog' :visible.sync="updateDialog" class="h-dialog2">
        <div class="h-dialogImg">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>{{uptitleDig}}</h1>
            </div>
          </div>
        </div>
        <div class="h-formLines">
&lt;!&ndash;            <h6 style="color: red;font-size: 0.14rem;margin-top: 0.1rem;">单位名称为大学时，请按实际情况维护用户分类(211/985)</h6>&ndash;&gt;
          <el-form ref="form" :model="add" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
            <el-form-item  label="单位名称" class="h-elformWrap-2" label-width="100" prop="deptName" :rules="[{ required: true, message: '请输入单位名称', trigger: 'change'},]">
                <el-select v-model="add.deptName"  remote filterable :filter-method="selectDept" clearable placeholder="请输入" allow-create filterable default-first-option
                           :remote-method="selectDept" @change="changeDeptName($event)" :rules="[{ required: true, message: '请输入单位名称', trigger: 'change'},]">
                    <el-option v-for="(item) in deptNameList"
                               :key="item.deptName"
                               :label="item.deptName"
                               :value="item.deptName">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item  label="渠道" class="h-elformWrap-2" label-width="100" prop="deptSourceChannel":rules="[{ required: true, message: '请输入渠道', trigger: 'change'},]" >
              <brselect category="sales_region" :v="add.deptSourceChannel" :showcode="true"  @change="changeChannel($event)" :rules="[{ required: true, message: '请输入渠道', trigger: 'change'},]"
                        v-model="add.deptSourceChannel" clearable></brselect>
            </el-form-item>
            <el-form-item  label="用户分类" class="h-elformWrap-2" label-width="100" prop="schoolTypeName" :rules="[{ required: true, message: '请输入用户分类', trigger: 'change'},]">
              <el-select v-model="add.schoolTypeName" :v="add.schoolTypeName" :rules="[{ required: true, message: '请输入用户分类', trigger: 'change'},]"
                         @change="changeSchoolType($event)"  placeholder="请选择" clearable>
                <el-option v-for="item in addressTypeList"
                           :key="item.id"
                           :label="item.userUnit"
                           :value="item.userUnit">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="地标性" class="h-elformWrap-2" prop="landmark" label-width="100"
                          :rules="[{ required: true, message: '请选择地标性', trigger: 'change'},]">
              <el-select v-model="add.landmark" @change="clickGetSeal" placeholder="请选择" clearable>
                <el-option label="KA" value="KA"></el-option>
                <el-option label="省级" value="省级"></el-option>
                <el-option label="地市级" value="地市级"></el-option>
                <el-option label="区县级及以下" value="区县级及以下"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="省" class="h-elformWrap-2" style="width: 33.333%" prop="province" :rules="[{ required: true, message: '必须输入选项', trigger: 'blur'},]">
              <el-select v-model="add.province" @change="handleItemChange1" placeholder="省">
                <el-option
                    v-for="item in shenglist"
                    :key="item.value"
                    :label="item.name"
                    :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="市" class="h-elformWrap-2" style="width: 33.333%" prop="city"
                          :rules="[{ required: true, message: '请输入市', trigger: 'change'},]">
              <el-select v-model="add.city" @change="handleItemChange2"
                         :rules="[{ required: true, message: '请输入市', trigger: 'change'},]"
                         placeholder="市">
                <el-option
                    v-for="item in arealist2"
                    :key="item.value"
                    :label="item.name"
                    :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="区" class="h-elformWrap-2" style="width: 33.333%" prop="area"
                          :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]">
              <el-select v-model="add.area"
                         :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]"
                         placeholder="区" @change="handleItemChange3">
                <el-option
                    v-for="item in arealist3"
                    :key="item.value"
                    :label="item.name"
                    :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
              <el-form-item label="上级" class="h-elformWrap-1" label-width="100" prop="stVal">
                  <treeselect
                          :multiple="false"
                          :options="options"
                          :flat="true"
                          :sort-value-by="sortValueBy"
                          :default-expand-level="1"
                          placeholder="请选择"
                          v-model="stVal"
                  />
                  <treeselect-value :value="stVal" />
              </el-form-item>
            <el-form-item label="详细地址" class="h-elformWrap-1"
                          :rules="[
                        { required: true, message: '必须输入选项', trigger: 'blur'},
                        {  max: 30, message: '长度在30个字符以内', trigger: 'blur' }
                    ]"
                                      prop="address">
                            <el-input v-model="add.address" style="width: 84%;"></el-input>
                        </el-form-item>
              <div style="font-size: 0.15rem;color: #ff2424;margin-bottom: 0.2rem;margin-left: 30px">*
                单位名称曾用名请用英文逗号形式隔开!
              </div>

              <el-form-item label="单位名称曾用名" class="h-elformWrap-1">
                <el-input type="textarea" style="border: #dedede 1px solid;
                                              width: 84%;" v-model="add.deptNameLog" ></el-input>
              </el-form-item>
                    </el-form>
                    <div style="display:flex;justify-content:center;margin-bottom:20px">
                        <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
                        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitUpdate()">提交</el-button>
                    </div>
                </div>
            </el-dialog>-->
        </div>
    </div>
</template>

<script>

import ss from '../../api/SystemService'
// import mapSrc from '../../assets/images/resourseevaimg/evaaddress.png'
// import mapShow from '../../components/order/mapShow'
// import the component
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import companyName from "@/components/basic/companyName.vue";
// import mapSrcVue from '../demo/mapShow.vue';
export default {
  components:{
    Treeselect,
    companyName
    // mapShow
    // mapSrcVue
  },
  data() {
    return {
      institutionalX:false,
      mapDialogVisible:false,// 地图选点
      // mapSrc:mapSrc,
      tableData: [],
      showhistory: false,
      instid: '',
      //表单
      formInline: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
        deptName: '',
        province: '',
        city: '',
        area: '',
          cucode:'',
          spStatus:'',
        deptSourceChannel:'',
        schoolTypeName: '',
      },
      updateId:null,
      //新增
      add: {
        id: '',
        deptName: '',
        deptType: '',
        status: '',
        countryId: '',
        country: '',
        provinceId: '',
        province: '',
        cityId: '',
        city: '',
        areaId: '',
        landmark:'',//地标性字段:KA,省级,地市级,区县级及以下
        area: '',
        shengobj: '',
        shiobj: '',
        quobj: '',
        selectId: '',
        address: '',
        subFlag: '',
        deptSourceChannel: '',
        longitude:'',
        latitude:'',
        parentCode:'',
        taskId:'',
        schoolTypeName:'',
        deptNameLog:'',
      },
      address:{
        name: '',
        provinceCenter:'',
      },
      tableSelectedList:[],
      newDialog: false,
      titleDig:"",
      uptitleDig:"",
      shenglist: [],
      arealist2:[],
      arealist3: [],
      addressTypeList:[],
      proSelect: {
        pcode: 0,
        level: 1,
      },
      updateDialog: false,
      insertFlag: false,
      reFlag: false,
      deptNameList:[],
      options:[],
      stVal:null,
    }
  },
  created() {
    this.query();
    this.getParentInfo();
  },
  methods: {
    // 地图选点 弹出
    mapHandleShow(){
      this.mapDialogVisible = true;
      // this.$nextTick(() => {
      //   this.$refs.mapSrcVue.init(id)
      // })
    },
    choseMapShow(objs) {
      console.log("关闭地图11", objs)
      this.add.address=objs.address;
      this.add.deptName=objs.title;
      this.add.province=objs.province;
      this.add.city= objs.city;
      this.add.area= objs.district;
      this.add.longitude = objs.lng;
      this.add.latitude = objs.lat;
      this.loadArea();
      this.mapDialogVisible = false;
    },
    handleFilter() {
      this.formInline.pageNo = 1;
      this.query();
    },
    query(){
      ss.nxAddress.selectPage(this.formInline).then(rd => {
        this.formInline.total = rd.total;
        this.tableData = rd.records;
      });
    },
    // 重置按钮
    resetData() {
      this.formInline.deptName = "";
      this.formInline.province = "";
      this.formInline.city = "";
      this.formInline.area = "";
      this.formInline.cucode="";
      this.formInline.deptSourceChannel = '',
      this.formInline.schoolTypeName = '',
      this.formInline.spStatus = '1';
      this.formInline.pageSize = 10;
      this.formInline.pageNo = 1;
      this.query();
    },
    genzongLiuch(r) {
      console.log(r);
      this.instid = r.instid;
      this.showhistory = true;
    },
    //单条查询
    handelDetail(id){
      this.updateId = id;
      console.log(this.updateId)
      /*ss.nxAddress.selectById(id).then(rd => {
        if (null == rd.msg.schoolTypeName || '' == rd.msg.schoolTypeName){
          rd.msg.schoolTypeName = '';
        }
        if (null == rd.msg.deptNameLog || '' == rd.msg.deptNameLog){
          rd.msg.deptNameLog = '';
        }
        this.add = rd.msg;
        var parentCode = new Array();
        parentCode.push(this.add.parentCode);
        this.stVal = this.add.parentCode;
        /!*this.loadArea();
        this.getParentInfo(rd.msg);*!/
      })*/
      this.institutionalX = true;
      this.titleDig = '修改用户单位';
    },
    //新增
    createAddr(v){
      this.updateId = null
      this.titleDig = "新建用户单位"
      /*this.newDialog = true
      this.insertFlag = true
      this.loadArea();*/
      this.institutionalX = true;
    },
    //取消
    exit() {
      this.closeDialog()
    },
    closeCompanyName(propData){
      console.log(propData);
      if (1 == propData){
        //关闭弹框
        this.closeDialog()
      }else if (2 == propData){
        //提交成功关闭弹框并查询数据
        this.closeDialog();
        this.query();
      }
    },
    //关闭弹窗,清空数据
    closeDialog(){
      this.institutionalX = false
      this.newDialog = false
      this.updateDialog = false
      this.insertFlag = false
      this.reFlag = false
      this.updateId = null
      //清空数据
      this.add.id = '';
      this.add.deptName = '';
      this.add.deptType = '';
      this.add.province = '';
      this.add.provinceId  = '';
      this.add.city = '';
      this.add.cityId = '';
      this.add.area = '';
      this.add.areaId = '';
      this.add.landmark = '';
      this.add.address = '';
      this.add.deptSourceChannel = '';
      this.add.parentCode = '';
      this.stVal = null;
      this.add.taskId = '';
      this.add.schoolTypeName = '';
    },
    //省份选择器
    handleItemChange1(o){
      this.add.provinceId = o;
      this.address = _.find(this.shenglist,{code:this.add.provinceId});
      this.add.province = this.address.name;
      ss.Dictservice.areaTreelist({code:o}).then(rd => {
        console.log("rddddddd",rd.zlist)
        this.add.city = '';
        this.add.area = '';
        this.add.landmark = '';
        this.arealist2 = rd.zlist;
        this.arealist3 = [];
      })
    },
    handleItemChange2(o){
      this.add.cityId = o;
      this.address = _.find(this.arealist2,{code:this.add.cityId});
      this.add.city = this.address.name;
      if ('1' == this.address.provinceCenter){
        this.add.landmark = '省级'
      }else if (null != this.add.deptName && (this.add.deptName.indexOf('市') != -1 && this.add.deptName.indexOf('区') == -1)){
        this.add.landmark = '地市级'
      }else {
        this.add.landmark = '区县级及以下'
      }
      this.arealist3 = _.find(this.arealist2,{code:o}).zlist
      console.log("arealist3",this.arealist3)
      this.arealist4 = []
    },
    handleItemChange3(o){
      this.add.areaId = o;
      this.address = _.find(this.arealist3,{code:this.add.areaId});
      this.add.area = this.address.name;
      if ('KA' != this.add.landmark && '省级' != this.add.landmark){
        if (null != this.add.deptName && ((this.add.deptName.indexOf('市') != -1 && this.add.deptName.indexOf('区') == -1) || '市辖区' == this.add.area)){
          this.add.landmark = '地市级'
        }else {
          this.add.landmark = '区县级及以下'
        }
      }
    },
    loadArea(i) {
      ss.Dictservice.arealist(this.proSelect).then(rd => {
        this.shenglist = rd;
        // for(let i = 0; i < this.shenglist.length; i++){
        //     this.shenglist[i].code = this.shenglist[i].code.substring(0,6);
        // }
        console.log("shenglist",this.shenglist)
      })
    },
    clickGetSeal(){
      console.log(this.add.landmark)
    },
    commitCreate(v){
        if(v == '1'){
            this.add.subFlag = '提交';
        }else if(v == '2'){
            this.add.subFlag = '重新提交';
        }
        this.add.countryId = '156';
        this.add.country = '中国';
        this.add.provinceId = this.add.provinceId.substring(0,6);
        this.add.cityId = this.add.cityId.substring(0,6);
        this.add.areaId = this.add.areaId.substring(0,6);
        this.add.parentCode = this.stVal;
        var data = this.add;
        console.log("address",data)
        ss.nxAddress.insertAddress(data).then(rd => {
            this.closeDialog();
            this.query();
        })
    },
    shenpiopt(row, flag){
      if(flag=="1"){
        this.$router.push({
          path: row.dburl,
          query: {ywid: row.id,taskid:row.taskId, instid: row.instid, taskstatus: '0'}
        })
        return;
      }
    },
    commitUpdate(){
      this.add.countryId = '156';
      this.add.country = '中国';
      this.add.provinceId = this.add.provinceId.substring(0,6);
      this.add.cityId = this.add.cityId.substring(0,6);
      this.add.areaId = this.add.areaId.substring(0,6);
      this.add.parentCode = this.stVal;
      var data = this.add;

      ss.nxAddress.updateAddress(data).then(rd => {
        this.closeDialog();
        this.query();
      })
    },
    chongxintijiao(id) {
      this.updateId = id;
      /*ss.nxAddress.selectById(id).then(rd => {
        if (null == rd.msg.schoolTypeName || '' == rd.msg.schoolTypeName){
          rd.msg.schoolTypeName = '';
        }
        if (null == rd.msg.deptNameLog || '' == rd.msg.deptNameLog){
          rd.msg.deptNameLog = '';
        }
        this.add = rd.msg;
        console.log("aaabbbccc",this.add)
        this.stVal = rd.msg.parentCode;
        this.institutionalX = true;
        this.titleDig = '新增用户单位';
        /!*this.reFlag = true;
        this.loadArea();*!/
      })*/
      this.institutionalX = true;
      this.titleDig = '新增用户单位';
    },

      //获取单位名称信息
      selectDept(value){
          ss.nxAddress.getDeptList(value).then(rd =>{
              this.deptNameList = rd.msg;
          })
      },
      //获取当前登录人创建的所有父级单位
      getParentInfo(v){
          ss.nxAddress.getParentInfo().then(rd =>{
              this.options = rd.msg;
          })
      },
    //渠道改变
      changeChannel(value){
        console.log("value",value)
        ss.nxAddress.getAddressTypeByChannel(value.code).then(rd =>{
          this.addressTypeList = rd.msg;
          this.add.schoolTypeName = '';
        })
      },
      changeSchoolType(value){
        this.add.schoolTypeName = value;
      },
      changeDeptName(val){
        console.log("changeDeptName",val)
        //调用接口，匹配省市区信息
          ss.nxAddress.getAddressByWl(val).then(rd=>{
              if(rd.f == true){
                  this.add.provinceId = rd.msg.provinceId;
                  this.add.province = rd.msg.province;
                  this.add.cityId = rd.msg.cityId;
                  this.add.city = rd.msg.city;
                  this.add.areaId = rd.msg.areaId;
                  this.add.area = rd.msg.area;
                  this.add.landmark = rd.msg.landmark;
                  this.add.address = rd.msg.address;
                  this.handleItemChangeN(this.add.provinceId);
              }
          })
          // for(var i = 0;i<this.deptNameList.length;i++){
          //     var dept = this.deptNameList[i];
          //     if(dept.deptName == val){
          //         this.add.provinceId = dept.provinceId;
          //         this.add.province = dept.province;
          //         // this.handleItemChange1(this.add.provinceId);
          //         this.add.cityId = dept.cityId;
          //         this.add.city = dept.city;
          //         // this.handleItemChange2(this.add.cityId);
          //         this.add.areaId = dept.areaId;
          //         this.add.area = dept.area;
          //         // this.handleItemChange3(this.add.areaId );
          //         this.handleItemChangeN(this.add.provinceId);
          //     }
          // }
          //根据单位名称获取关键字
          ss.nxAddressKeywords.matchKeywords(val).then(rd=>{
              if(rd.msg != null){
                  this.add.deptSourceChannel = rd.msg.channelCode;
                  this.add.schoolTypeName = rd.msg.userUnit;
                  this.matchChannel(rd.msg.channelCode)
              }
          })
      },
      matchChannel(value){
          console.log("value",value)
          ss.nxAddress.getAddressTypeByChannel(value).then(rd =>{
              this.addressTypeList = rd.msg;
              // this.add.schoolTypeName = '';
          })
      },
      //地址选择器-新
      handleItemChangeN(o){
          this.address = _.find(this.shenglist,{code:this.add.provinceId});
          // this.add.province = this.address.name;
          ss.Dictservice.areaTreelist({code:o}).then(rd => {
              this.arealist2 = rd.zlist;
              this.arealist3 = [];
              this.address = _.find(this.arealist2,{code:this.add.cityId});
              // this.add.city = this.address.name;
              this.arealist3 = _.find(this.arealist2,{code:o}).zlist
          })
      },
      formatDate(row, column) {
          // 获取单元格数据
          let data = row[column.property]
          if(data == null) {
              return null
          }
          let dt = new Date(data)
          return this.$util.riQi3(dt);
      },

  },
}
</script>

<style scoped>
    .xiangmu .h-piece, .h-mrt30 {
        margin: 20px;
    }

    .h-formBtnOut .h-mr20 {
        margin-left: 1rem !important;
    }

    .D-date .el-cascader {
        line-height: 0;
    }
    .tableclslist	.h-tableLink{
        padding:0px 2px!important;
    }
</style>
<style>
    .dz-date .h-dialogForm .h-elformWrap-2{
        width: 50%!important;
        padding-right: 0
    }
    .dz-date .h-elformWrap-2 .el-form-item__label{
        width: 33%!important;
    }
    .dz-date .h-elformWrap-2 .el-form-item__content{
        width: 62%!important;
    }
    .h-formbLine.qlplshyj .h-elformWrap-1 .el-form-item__label{
        width: 20%;
    }
    .h-formbLine.qlplshyj .h-elformWrap-1 .el-form-item__content{
        width: 80%;
    }
</style>
